import { useModalContentToggler } from '@components'

import { Link, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { SubjectReconciliationModalStateId } from '../../../../enums/SubjectReconciliationModalStateId'

export const LinkToBankLines = (): ReactElement => {
  const { t } = useTranslation()
  const { setActiveState } = useModalContentToggler()

  const handleLinkClick = useCallback(() => {
    setActiveState(SubjectReconciliationModalStateId.BankLines)
  }, [setActiveState])

  return (
    <>
      <Space></Space>
      <Text colorVariant="secondary">
        {t('bill.payment_reconcile.do_you_want_reconcile')}{' '}
        <Text as="span">
          <Link onClick={handleLinkClick}>{t('bill.payment_reconcile.choose_from_bank_transactions')}</Link>
        </Text>
      </Text>
    </>
  )
}
